module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot52-7839b075be632b267bb5101f67da7705.jpg";